import { put, call, getContext } from "redux-saga/effects";

import { claimStatus } from "../../Services/ClaimCashless";

export function* claimStatusSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(claimStatus, payload);

    yield put({ type: "REQ_CLAIM_STATUS_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CLAIM_STATUS_FAILED", errData: e });
  }
}
